/* club-map.js — isolert initialisering for Shopify-artikler */
(function () {
  // Finn wrapperen for akkurat denne instansen
  const root = document.querySelector('[data-clubmap]');
  if (!root) return;

  // Elementer
  const countryBar = root.querySelector('#clubmap-countrybar');
  const dropdown   = root.querySelector('#clubmap-dropdown');
  const btnNearby  = root.querySelector('#clubmap-nearby');
  const btnReset   = root.querySelector('#clubmap-reset');
  const mapEl      = root.querySelector('#clubmap-map');
  const listEl     = root.querySelector('#clubmap-list');

  // Data
  const clubs = {
    NO: [
      { name:"Agder Airsoft Klubb", area:"Kristiansand / Agder", link:"https://www.google.com/maps/search/Agder+Airsoft+Klubb,+Kristiansand", coords:[58.1599,8.0182] },
      { name:"Airsoft Klubben (Vennesla)", area:"Vennesla / Agder", link:"https://www.google.com/maps/search/Airsoft+Klubben+(Vennesla)", coords:[58.2742,7.9749] },
      { name:"Molde Airsoftklubb", area:"Molde / Møre og Romsdal", link:"https://www.google.com/maps/search/Molde+Airsoftklubb,+Molde", coords:[62.7374,7.1607] },
      { name:"Oslo Viken Airsoft Klubb", area:"Viken / Oslo", link:"https://www.oslovikenairsoftklubb.com", coords:[59.9139,10.7522] },
      { name:"Rogaland Airsoft", area:"Rogaland", link:"https://rogalandairsoft.com/", coords:[58.9690,5.7331] },
      { name:"Tromsø Airsoft Klubb", area:"Tromsø", link:"https://www.facebook.com/TromsoAirsoftklubb/", coords:[69.6496,18.9560] },
      { name:"Viking Airsoft", area:"Sandnes / Rogaland", link:"https://www.facebook.com/vikingairsoft", coords:[58.8524,5.7352] },
      { name:"Østfold Milsim", area:"Østfold", link:"https://www.ostfoldmilsim.no", coords:[59.2845,11.1097] }
    ],
    SE: [
      { name:"Malmö Airsoft", area:"Malmö", link:"https://www.google.com/maps?q=Malmo+airsoft", coords:[55.605,13.0038] },
      { name:"Skaraborgs Airsoftförening (SKAF)", area:"Skaraborg", link:"https://www.skbairsoft.se/", coords:[58.3903,13.8451] },
      { name:"Stockholm Airsoft Club", area:"Stockholm", link:"https://www.google.com/maps?q=Stockholm+airsoft", coords:[59.334,18.063] },
      { name:"Västsvenska Airsoftföreningen (VSAF)", area:"Göteborg", link:"https://www.vsaf.se/", coords:[57.7089,11.9746] }
    ],
    DK: [
      { name:"Aarhus Milsim", area:"Aarhus", link:"https://www.google.com/maps?q=Aarhus+airsoft", coords:[56.1629,10.2039] },
      { name:"København Airsoft Klub", area:"København", link:"https://www.google.com/maps?q=Copenhagen+airsoft", coords:[55.6761,12.5683] },
      { name:"Odense Airsoft", area:"Odense", link:"https://www.google.com/maps?q=Odense+airsoft", coords:[55.4038,10.4024] }
    ]
  };

  // Lastehjelpere for Leaflet (kun én gang)
  function ensureLeaflet(callback){
    if (window.L) { callback(); return; }

    const cssId = 'leaflet-css';
    const jsId  = 'leaflet-js';
    if (!document.getElementById(cssId)) {
      const link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);
    }
    if (!document.getElementById(jsId)) {
      const script = document.createElement('script');
      script.id = jsId;
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.onload = callback;
      document.head.appendChild(script);
    } else {
      // Script finnes men kan være i ferd med å laste
      const s = document.getElementById(jsId);
      if (s.dataset.ready === '1') callback();
      else s.addEventListener('load', callback, { once:true });
    }
  }

  let activeCountry = 'NO';
  let map, markers = [];

  function clearMarkers(){ markers.forEach(m => map.removeLayer(m)); markers = []; }

  function fitToMarkers(){
    if(!markers.length){ map.setView([60.5, 12.0], 4); return; }
    const g = new L.featureGroup(markers);
    map.fitBounds(g.getBounds().pad(0.2));
  }

  function populateDropdown(data){
    dropdown.innerHTML = '<option value="">Velg klubb …</option>';
    data.forEach((c,idx)=>{
      const opt = document.createElement('option');
      opt.value = String(idx);
      opt.textContent = c.name;
      dropdown.appendChild(opt);
    });
  }

  function renderList(data){
    listEl.innerHTML = '';
    data.forEach(c=>{
      const card = document.createElement('div');
      card.className = 'clubmap__card';
      card.innerHTML = `
        <div class="clubmap__name">${c.name}</div>
        <div class="clubmap__meta">${c.area}</div>
        <div class="clubmap__actions">
          <a class="clubmap__link" href="${c.link}" target="_blank" rel="noopener">Nettside / Info</a>
          <a class="clubmap__link clubmap__link--dark" href="https://www.google.com/maps?q=${c.coords[0]},${c.coords[1]}" target="_blank" rel="noopener">Åpne i Kart</a>
        </div>`;
      card.addEventListener('click', ()=> map.setView(c.coords, 11));
      listEl.appendChild(card);
    });
  }

  function render(){
    const data = [...(clubs[activeCountry]||[])].sort((a,b)=> a.name.localeCompare(b.name,'no'));
    populateDropdown(data);
    renderList(data);

    clearMarkers();
    data.forEach(c=>{
      const m = L.marker(c.coords).addTo(map);
      m.bindPopup(`<b>${c.name}</b><br>${c.area}<br><a href="${c.link}" target="_blank" rel="noopener">Lenke</a>`);
      markers.push(m);
    });
    fitToMarkers();
  }

  function init(){
    map = L.map(mapEl, { zoomControl:true, scrollWheelZoom:true });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution:'© OpenStreetMap' }).addTo(map);
    map.setView([60.5, 12.0], 5);

    // Landbytte
    countryBar.addEventListener('click', e=>{
      const btn = e.target.closest('.clubmap__pill'); if (!btn) return;
      root.querySelectorAll('.clubmap__pill').forEach(x=>x.classList.remove('clubmap__pill--active'));
      btn.classList.add('clubmap__pill--active');
      activeCountry = btn.dataset.cc || 'NO';
      render();
    });

    // Dropdown
    dropdown.addEventListener('change', e=>{
      const idx = parseInt(e.target.value, 10);
      if (Number.isNaN(idx)) return;
      const data = [...(clubs[activeCountry]||[])].sort((a,b)=> a.name.localeCompare(b.name,'no'));
      const c = data[idx];
      if (c){
        map.setView(c.coords, 12);
        const marker = markers.find(m=>{
          const p = m.getLatLng();
          return Math.abs(p.lat - c.coords[0]) < 1e-6 && Math.abs(p.lng - c.coords[1]) < 1e-6;
        });
        if (marker) marker.openPopup();
      }
    });

    // Posisjon
    btnNearby.addEventListener('click', ()=>{
      if (!navigator.geolocation){ alert('Geolokasjon støttes ikke i denne nettleseren.'); return; }
      navigator.geolocation.getCurrentPosition(pos=>{
        const { latitude:lat, longitude:lon } = pos.coords;
        const you = L.circleMarker([lat, lon], { radius:8, color:'#111', fillColor:'#fff', fillOpacity:.9 }).addTo(map);
        you.bindPopup('📍 Du er her').openPopup();
        map.setView([lat, lon], 9);
      }, ()=> alert('Kunne ikke hente posisjon.'));
    });

    // Nullstill
    btnReset.addEventListener('click', ()=>{
      dropdown.value = '';
      render();
    });

    // Første rendring
    render();
  }

  // Start
  ensureLeaflet(init);
})();
